import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import { AdministrationServicePath, HEALTH_INSURANCES } from "../../../utils/constants";
import ListHealthInsurances from "./List";
import CreateHealthInsurances from "./Create";
import EditHealthInsurances from "./Edit";
import ShowHealthInsurances from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <HealthAndSafetyIcon />,
  name: AdministrationServicePath + HEALTH_INSURANCES,
  title: "Здравни осигуровки",
  list: <ListHealthInsurances />,
  create: <CreateHealthInsurances />,
  createPermissions: permissions.canManageHealthInsurances,
  edit: <EditHealthInsurances />,
  editPermissions: permissions.canManageHealthInsurances,
  show: <ShowHealthInsurances />,
  showPermissions: permissions.canPreviewHealthInsurances,
  permission: permissions.canPreviewHealthInsurances,
};
